export default {
  // Får implementeras av den som ärver
  // data(){
  //   return {
  //     _contract: null
  //   }
  // },
  computed: {
    number(){
      if(this._contract)
        return this._contract.contractNumber;
    },

    dwellingNumber(){
      if(this._contract)
        return this._contract.dwellingNumber
    },

    /**
     * T.ex. "parking"
     */
    rentalObjectType(){
      if(this._contract)
        return this._contract.rentalObjectType
    },

    /**
     * T.ex. BILPL2
     */
    rentalObjectTypeCode(){
      if(this._contract && this._contract.rentalObject)
        return this._contract.rentalObject.rentalObjectTypeCode;
    },

    dwellingNumber(){
      if(this._contract)
        return this._contract.dwellingNumber
    },
    // subCaption(){
    //   if(!this._contract)
    //     return;

    //   return this._contract.__rentObject.subCaption
    // },
    // area(){
    //   if(this._contract)
    //     return this._contract.__rentObject.quantityBRA
    // },
    validContractPeriodFrom(){
      if(this._contract && this._contract.validContractPeriodFrom)
        return this._contract.validContractPeriodFrom.replace(/\s+/g, '')
    },

    validContractPeriodTo(){
      if(this._contract && this._contract.validContractPeriodTo)
        return this._contract.validContractPeriodTo.replace(/\s+/g, '')
    },

    rent(){
      if(this._contract)
        return Math.ceil(this._contract.baseRent)
    },

    rentYear(){
      if(this._contract)
        return Math.round(this._contract.rentYear)
    },

    cancelPolicy(){
      if (this._contract) {
        return this._contract.cancelPolicyTenant.quantity + " " + this._contract.cancelPolicyTenant.unit;
      }
    },

    fromDate(){
      if (this._contract && this._contract.fromDate) {
        return this._contract.fromDate;
      }
    },

    /**
     * Kontraktets status.
     * Typ "valid"
     */
    status(){
      if(this._contract)
        return this._contract.status
    },

    // blueprint(){
    //   if(this._contract && this._contract.__rentObject && this._contract.__rentObject.images){
    //     const blueprint = this._contract.__rentObject.images.find(img => img.typeCaption !== 'Bostadsritning')

    //     if(blueprint)
    //       return blueprint.url;
    //   }
    // }
  }
}
